import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { InstitucionPersonaDTO } from 'src/app/core/models/bienestar/institucionPersona-DTO';

const API_URL = environment.apiUrlBienestar;

@Injectable()
export class InstitucionPersonaService {
    header = new Headers({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient) {}

    getInstitucionPersonaService() {
        return this.http.get<BodyListResponse<InstitucionPersonaDTO>>(
            API_URL + '/api/v1/institucionPersona/todos'
        );
    }

    guardarInstitucionPersonaService(bienestarInstitucionPersonaDTO: InstitucionPersonaDTO) {
        return this.http.post<InstitucionPersonaDTO>(API_URL + '/api/v1/institucionPersona', bienestarInstitucionPersonaDTO);
    }

    getInstitucionPersonaPorCodigoInstitucionPersonaService(codigoInstitucionPersona: string) {
        return this.http.get<BodyResponse<InstitucionPersonaDTO>>(
            API_URL + '/api/v1/institucionPersona/' + codigoInstitucionPersona
        );
    }
}
